
import React, { useEffect, useRef, useState } from "react"
import './../../App.css'
import {handleLoginClick, LoginProps} from "../Login/LoginService"
import { AlertType } from "../../Utils/Types"

export const LandingPage = () => {

    const [active, setActive] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const videoRef = useRef<any>(null)

    useEffect(() => {
            
            videoRef.current.currentTime = 0
//            videoRef.current.play()
            
        }, [])

    const closeModal = () => {
        setActive("")
    }

    const openModalLogin = () => {
         setActive('active')
    }

    const SingIn = async () => {

        if (email === ""){
            setError("E-mail não informado")
            return
        }

        if (password === ""){
            setError("Senha não informada")
            return
        }

        setLoading(true)
        setError("")

        let resp: LoginProps = await handleLoginClick(email, password, true)

        if (resp.error) {            
            setError(resp.msg)
            setLoading(false)
        } else {
            if (resp.hash) {
                localStorage.setItem('@ecommerce/hash', resp.hash)
                localStorage.setItem('@ecommerce/name', resp.name || '')
                localStorage.setItem('@ecommerce/tema', resp.tema || 'light')
                localStorage.setItem('@ecommerce/cor_tema', resp.cor_tema || 'bg-blue-600')
                localStorage.setItem('@ecommerce/cor_bg_menu', resp.cor_hover_menu || 'hover:bg-blue-700')
                localStorage.setItem('@ecommerce/cor_bg_nav', resp.cor_hover_sub_menu || 'hover:bg-blue-800')
                localStorage.setItem('@ecommerce/cor_barra', resp.cor_hover_sub_menu?.replace("hover:bg", "scrollbar-thumb") || 'scrollbar-thumb-blue-800')
                localStorage.setItem('@ecommerce/dados_empresa', JSON.stringify(resp.dadosEmpresa))
                localStorage.setItem('imageLogo', resp.dadosEmpresa.url_logo || '')
                window.location.href = '/'
            }
        }

        
    }

    const passwordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
    }

    const emailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }
            
    return <html>
        <head>
                    <meta charSet="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <title>GestorWEB - O ERP completo para o MEI</title>
                    
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
                    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700;900&display=swap" rel="stylesheet" />
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css" />

                    <script src="https://unpkg.com/@phosphor-icons/web"></script>
                    
                </head>                
                <body>
                        <header className="header">
                            <div className="container">
                                <a href="#" className="logo">GestorWEB</a>
                                <div>
                                    <button onClick={openModalLogin} className="btn-header" style={{backgroundColor: 'transparent', border: '1px solid white', color: 'white', marginRight: '15px'}}>
                                        Login
                                    </button>
                                    <a href="https://wa.me/5532999211545?text=Ol%C3%A1!%20Vi%20o%20site%20do%20GestorWEB%20e%20gostaria%20de%20iniciar%20meu%20teste%20gr%C3%A1tis." target="_blank" className="btn-header">Teste Agora</a>
                                </div>
                            </div>
                        </header>    

                        <main>
                            <section id="hero">
                                <div className="container">
                                    <h1>Chega de Planilhas! A Gestão do seu MEI, Finalmente Simples e Completa.</h1>
                                    <p>Tome o controle total do seu negócio, do estoque ao financeiro, de onde estiver. Nosso sistema 100% online foi feito para você, microempreendedor.</p>
                                    <a href="https://wa.me/5532999211545?text=Ol%C3%A1!%20Vi%20o%20site%20do%20GestorWEB%20e%20gostaria%20de%20iniciar%20meu%20teste%20gr%C3%A1tis." target="_blank" className="btn btn-principal">Quero Organizar Meu Negócio Agora</a>
                                    <p className="subtext">Teste grátis por 7 dias. Sem compromisso.</p>
                                </div>
                            </section>

                            <section id="dores">
                                <div className="container">
                                    <h2>Você se sente <span>perdido</span> no controle da sua empresa?</h2>
                                    <div className="dores-grid">
                                        <div className="dor-card"><i className="fa-solid fa-file-excel"></i><h3>Planilhas Confusas</h3><p>Vendeu um produto que não tinha mais ou se perdeu nas contas?</p></div>
                                        <div className="dor-card"><i className="fa-solid fa-hand-holding-dollar"></i><h3>Cobranças Atrasadas</h3><p>Não sabe exatamente quem deve te pagar e quando?</p></div>
                                        <div className="dor-card"><i className="fa-solid fa-clock"></i><h3>Falta de Tempo</h3><p>Gasta mais tempo com burocracia do que com suas vendas?</p></div>
                                        <div className="dor-card"><i className="fa-solid fa-chart-line"></i><h3>Incerteza do Lucro</h3><p>Não tem certeza se o seu negócio está realmente dando lucro?</p></div>
                                        <div className="dor-card"><i className="fa-solid fa-boxes-stacked"></i><h3>Estoque Parado</h3><p>Dinheiro parado em produtos que não vendem? Não sabe a hora certa de comprar mais?</p></div>
                                        <div className="dor-card"><i className="fa-solid fa-wallet"></i><h3>Finanças Misturadas</h3><p>O dinheiro da empresa se mistura com o seu pessoal no fim do dia?</p></div>
                                    </div>
                                </div>
                            </section>

                            <section id="solucao">
                                <div className="container">
                                    <div className="solucao-content">
                                        <div className="solucao-text">
                                            <h2>Sua empresa na <span>palma da sua mão.</span></h2>
                                            <p>Criamos um sistema de gestão completo, mas incrivelmente fácil de usar. Centralize tudo o que você precisa em um único lugar e tenha mais tempo para focar no que realmente importa: <strong>o crescimento do seu negócio.</strong></p>
                                            <ul>
                                                <li>✅ <strong>100% Online:</strong> Acesse do computador, celular ou tablet.</li>
                                                <li>✅ <strong>Feito para o MEI:</strong> Sem telas complicadas ou funções que você nunca vai usar.</li>
                                                <li>✅ <strong>Seguro e Confiável:</strong> Seus dados protegidos com a mesma segurança de grandes bancos.</li>
                                            </ul>
                                        </div>
                                        <div className="solucao-video">
                                            <div className="video-placeholder">                                                
                                                <video ref={videoRef} controls>
                                                    <source src="/publicidade.mp4" type="video/mp4"></source>
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section id="funcionalidades">
                                <div className="container">
                                    <h2>Tudo o que você precisa para <span>decolar</span> 🚀</h2>
                                    <div className="funcionalidades-grid">
                                        <div className="func-card"><i className="fa-solid fa-boxes-stacked"></i><h3>Estoque Inteligente</h3><p>Cadastre produtos com variações (cor, tamanho). Saiba exatamente o que entra e sai e nunca mais perca uma venda por falta de produto.</p></div>
                                        <div className="func-card"><i className="fa-solid fa-sack-dollar"></i><h3>Financeiro Sob Controle</h3><p>Gerencie contas a pagar/receber, fluxo de caixa e cartões. Saiba exatamente para onde seu dinheiro está indo e quando ele vai entrar.</p></div>
                                        <div className="func-card"><i className="fa-solid fa-credit-card"></i><h3>Controle de Cartões</h3><p>Chega de confusão com as taxas e datas de recebimento das maquininhas. Dê baixa automática e tenha clareza total.</p></div>
                                        <div className="func-card"><i className="fa-solid fa-arrow-right-arrow-left"></i><h3>Vendas Integradas</h3><p>Crie um pedido de venda e veja seu estoque e financeiro serem atualizados automaticamente. Menos retrabalho, mais agilidade.</p></div>
                                        <div className="func-card"><i className="fa-solid fa-chart-pie"></i><h3>Dashboard Intuitivo</h3><p>Gráficos simples mostram suas vendas e saúde financeira. Tome decisões inteligentes baseadas em dados reais, não em suposições.</p></div>
                                        <div className="func-card"><i className="fa-solid fa-mobile-screen-button"></i><h3>Acesso de Onde Estiver</h3><p>Consulte preços, estoque e relatórios pelo celular, tablet ou computador. Sua empresa no seu bolso, 24h por dia.</p></div>
                                    </div>
                                </div>
                            </section>

                            <section id="depoimentos">
                                <div className="container">
                                    <h2>O que nossos <span>clientes</span> estão dizendo</h2>
                                    <div className="depoimentos-grid">
                                        <div className="depoimento-card"><p>"Eu vivia em um mar de papéis e planilhas. Com o GestorWEB, em 15 minutos por dia eu organizo tudo! Minha paz de espírito não tem preço."</p><div className="depoimento-autor"><div className="autor-info"><h4>Joana S. - Perfumaria</h4><span>Ubá, MG</span></div></div></div>
                                        <div className="depoimento-card"><p>"O controle de contas a receber mudou meu negócio. Agora eu sei exatamente quem precisa pagar e quando. Meu fluxo de caixa melhorou 30%!"</p><div className="depoimento-autor"><div className="autor-info"><h4>Carlos P. - Loja de Celular e Eletrônicos</h4><span>Rio Pomba, MG</span></div></div></div>
                                        <div className="depoimento-card"><p>"Saber qual produto mais vende pelo dashboard me ajudou a comprar melhor e aumentar meu lucro. É simples e direto ao ponto. Recomendo demais!"</p><div className="depoimento-autor"><div className="autor-info"><h4>Mariana L. - Venda de Doces</h4><span>Serra, ES</span></div></div></div>
                                    </div>
                                </div>
                            </section>
                            
                            <section id="preco">
                                <div className="container">
                                    <h2>Escolha o plano ideal para a <span>sua fase</span>.</h2>
                                    <p style={ {textAlign: 'center', maxWidth: '600px', margin: '0 auto 20px auto'} }>Comece com o essencial para organizar a casa e evolua para ter mais inteligência e vender mais.</p>
                                    <div className="preco-cards">
                                    <div className="preco-card">
                                        <h3>MEI Essencial</h3>
                                        <p className="preco">R$ 49,95<span>/mês</span></p>
                                        <p>Ideal para organizar suas finanças e estoque de uma vez por todas.</p>
                                        <ul>
                                            <li><i className="fa-solid fa-check"></i> Controle de Estoque e Vendas</li>
                                            <li><i className="fa-solid fa-check"></i> Financeiro (Contas a Pagar/Receber)</li>
                                            <li><i className="fa-solid fa-check"></i> Controle de Taxas de Cartões</li>
                                            <li><i className="fa-solid fa-check"></i> Dashboard de Vendas</li>
                                            <li><i className="fa-solid fa-check"></i> 1 Usuário</li>
                                            <li><i className="fa-solid fa-check"></i> Suporte via E-mail e Chat</li>
                                        </ul>
                                        <a href="https://wa.me/5532999211545?text=Ol%C3%A1!%20Vi%20o%20site%20do%20GestorWEB%20e%20gostaria%20de%20iniciar%20meu%20teste%20gr%C3%A1tis." target="_blank" className="btn btn-principal">Começar Teste Grátis</a>
                                    </div>
                                
                                    <div className="preco-card destaque">
                                        <div className="selo-popular">Mais Popular</div>
                                        <h3>MEI Crescimento</h3>
                                        <p className="preco">R$ 99,90<span>/mês</span></p>
                                        <p>Tudo do Essencial, mais ferramentas para tomar decisões e vender mais.</p>
                                        <ul>
                                            <li><i className="fa-solid fa-check"></i> <strong>Tudo do plano Essencial</strong></li>
                                            <li><i className="fa-solid fa-check"></i> Até 3 Usuários</li>
                                            <li><i className="fa-solid fa-check"></i> Suporte Prioritário via <strong>WhatsApp</strong></li>
                                            <li><i className="fa-solid fa-check"></i> Emissão de Orçamentos em PDF</li>
                                            <li><i className="fa-solid fa-check"></i> Relatórios Avançados <span className="em-breve">(em breve)</span></li>
                                            <li><i className="fa-solid fa-check"></i> Catálogo de Produtos Online <span className="em-breve">(em breve)</span></li>
                                            <li><i className="fa-solid fa-check"></i> Exportações para Excel <span className="em-breve">(em breve)</span></li>
                                            <li><i className="fa-solid fa-check"></i> Emissão de NFe <span className="em-breve">(em breve)</span></li>
                                        </ul>
                                        <a href="https://wa.me/5532999211545?text=Ol%C3%A1!%20Vi%20o%20site%20do%20GestorWEB%20e%20gostaria%20de%20iniciar%20meu%20teste%20gr%C3%A1tis." target="_blank" className="btn btn-principal">Começar Teste Grátis</a>
                                    </div>
                                    </div>
                                </div>
                            </section>

                            <section id="faq">
                                <div className="container">
                                    <h2>Ainda tem <span>dúvidas?</span></h2>
                                    <div className="faq-container">
                                        <details className="faq-item"><summary>É muito difícil de usar? Preciso de treinamento?</summary><div><p>Não! Nosso sistema foi desenhado para ser intuitivo. A maioria dos nossos clientes começa a usar e cadastrar seus produtos no mesmo dia, sem nenhuma ajuda.</p></div></details>
                                        <details className="faq-item"><summary>Preciso instalar alguma coisa no meu computador?</summary><div><p>Absolutamente nada! O sistema é 100% web. Tudo o que você precisa é de um navegador de internet (como Chrome, Firefox ou Safari) em qualquer dispositivo.</p></div></details>
                                        <details className="faq-item"><summary>Meus dados estão seguros?</summary><div><p>Sim. Usamos criptografia de ponta e servidores seguros para garantir que suas informações estejam sempre protegidas.</p></div></details>
                                        <details className="faq-item"><summary>Posso cancelar quando quiser?</summary><div><p>Sim! Você não tem nenhum contrato de fidelidade e pode cancelar sua assinatura a qualquer momento, sem burocracia.</p></div></details>
                                    </div>
                                </div>
                            </section>

                            <section id="cta-final">
                                <div className="container">
                                    <h2>Dê o próximo passo na gestão do seu MEI.</h2>
                                    <p>Profissionalize sua gestão, economize tempo e tenha a clareza que você precisa para crescer.</p>
                                    <a href="https://wa.me/5532999211545?text=Ol%C3%A1!%20Vi%20o%20site%20do%20GestorWEB%20e%20gostaria%20de%20iniciar%20meu%20teste%20gr%C3%A1tis." target="_blank" className="btn btn-principal">Quero o Controle Total do Meu Negócio!</a>
                                    <p className="subtext">Teste Grátis por 7 dias. Rápido, fácil e sem compromisso.</p>
                                </div>
                            </section>
                        </main>

                        <footer className="footer">
                            <div className="container">
                                <p>&copy; 2025 GestorWEB por Tocantins Informática. Todos os direitos reservados.</p>
                                <p><a href="#">Termos de Uso</a> | <a href="#">Política de Privacidade</a></p>
                            </div>
                        </footer>

                        <div id="loginModal" className={`login-modal-overlay ${active}`}>
                            <div className="login-modal-content">
                                <button onClick={closeModal} className="login-modal-close-btn">&times;</button>
                                <form id="login-form" className="login-modal-form">
                                    <h2>Acesse sua Conta</h2>
                                    <div className="input-group">
                                        <i className="ph ph-user"></i>
                                        <input type="email" id="login-email" placeholder="seuemail@exemplo.com" required autoComplete="off" value={email} onChange={emailChange}/>
                                    </div>
                                    <div className="input-group">
                                        <i className="ph ph-lock"></i>
                                        <input type="password" id="login-password" placeholder="••••••••" required autoComplete="off" value={password} onChange={passwordChange}/>
                                        <i className="ph ph-eye" id="togglePassword"></i>
                                    </div>

                                    {error && 
                                        <div className="options">
                                            <span className="text-error">{error}</span>
                                        </div>
                                    }
                                    
                                    <div className="options">
                                        <a href="#">Esqueci minha senha</a>
                                    </div>
                                    <button disabled={loading} onClick={SingIn} type="button" className="btn btn-principal btn-acessar">
                                        {loading && 
                                            'Aguarde'
                                        }

                                        {!loading && 
                                            'Acessar'
                                        }
                                        
                                    </button>
                                </form>
                            </div>
                        </div>
                    </body>                
           </html>        
     
}